import React, { useEffect, useState } from "react";
import Api from "../../../config/Api";
import { Bar } from "react-chartjs-2";

const Graph1 = () => {
  const [graph, setGraph] = useState({ labels: [], amounts: [] });

  const getGraph = async () => {
    const { data } = await Api("linechart", "POST", {});

    if (data?.status === 1) {
      setGraph(data.data || { labels: [], amounts: [] });
    }
  };

  useEffect(() => {
    getGraph();
    // eslint-disable-next-line
  }, []);

  const chartData = {
    labels: graph.labels,
    datasets: [
      {
        label: "Total Released Amount",
        data: graph.amounts,
        backgroundColor: graph.labels.map((_, index) => {
          const colors = [
            "rgba(34, 75, 139, 0.8)",
            "rgba(220, 53, 69, 0.8)",
            "rgba(25, 135, 84, 0.8)",
            "rgba(255, 193, 7, 0.8)",
            "rgba(13, 110, 253, 0.8)",
            "rgba(111, 66, 193, 0.8)",
            "rgba(253, 126, 20, 0.8)",
            "rgba(32, 201, 151, 0.8)",
            "rgba(214, 51, 132, 0.8)",
            "rgba(108, 117, 125, 0.8)",
          ];
          return colors[index % colors.length];
        }),
        borderRadius: 6,
      },
    ],
  };

  const option = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const val = Number(ctx.raw || 0);
            return `₹ ${val.toLocaleString("en-IN")}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            const v = Number(value || 0);
            if (v >= 10000000) return (v / 10000000).toFixed(1) + " Cr";
            if (v >= 100000) return (v / 100000).toFixed(1) + " L";
            if (v >= 1000) return (v / 1000).toFixed(1) + " K";
            return v;
          },
        },
      },
    },
  };

  return (
    <div className="bg-white rounded-4 p-3">
      <div className="mb-2">
        <h6 className="fw-bold mb-0 text-dark">
          District Wise Total Released Payment
        </h6>
      </div>

      <div style={{ height: 380 }}>
        <Bar options={option} data={chartData} />
      </div>
    </div>
  );
};

export default Graph1;